import axios from "@lib/axios";
import { getCookie } from "../../../lib/helpers";
import { store } from "../redux/store";

const rootUrl =
  process.env.NODE_ENV !== "development"
    ? "http://inkind/api/v5/"
    : "http://localhost:3000/api/v5/";
let userToken = getCookie("userToken") || null;

function takeUTM(bodyFormData, utmUnparsed) {
  const utm = JSON.parse(utmUnparsed);
  bodyFormData.append("utm_campaign", utm.utm_campaign || "");
  bodyFormData.append("utm_content", utm.utm_content || "");
  bodyFormData.append("utm_medium", utm.utm_medium || "");
  bodyFormData.append("utm_source", utm.utm_source || "");
  bodyFormData.append("utm_term", utm.utm_term || "");
}
export async function sendBulkGift(data) {
  const auth = userToken ? "Bearer ".concat(userToken) : "";
  const axiosHeaders = {
    headers: {
      Authorization: auth,
    },
  };
  const url = "/api/v5/bulk_gifts";
  return await axios.post(url, data, axiosHeaders);
}

export async function handleSubscribe(
  stripe_token_id,
  stripe_source_id,
  email,
  userToken = null,
  utm,
  headers,
) {
  var thisStore = store.getState();
  var slug = thisStore.nav.curSubscriptionTier.slug;
  const auth = userToken ? "Bearer ".concat(userToken) : "";
  const axiosHeaders = {
    headers: {
      Authorization: auth,
      ...headers,
    },
  };
  const bodyFormData = new FormData();
  bodyFormData.append("lvl", slug);
  bodyFormData.append("tos_check_box", 1);
  bodyFormData.append("email", email);
  if (stripe_token_id) {
    bodyFormData.append("stripe_token_id", stripe_token_id);
  } else if (stripe_source_id) {
    bodyFormData.append("stripe_source_id", stripe_source_id);
  }
  takeUTM(bodyFormData, utm);
  const url = "/checkout/subscribe";

  return await axios.post(url, bodyFormData, axiosHeaders);
}

export async function sendPayment(
  stripe_token_id,
  stripe_source_id,
  email,
  gift_card_option_id,
  userToken = null,
  utm,
  ikPass,
  ikPassSingle,
  existingSubscription,
  header,
) {
  const auth = userToken ? "Bearer ".concat(userToken) : "";
  const axiosHeaders = {
    headers: {
      Authorization: auth,
      ...header,
    },
  };
  const bodyFormData = new FormData();
  if (!!ikPass) {
    bodyFormData.append(
      "inkind_cash_subscription_tier_id",
      gift_card_option_id,
    );
  } else if (!!ikPassSingle) {
    bodyFormData.append("gift_card_option_id", gift_card_option_id);
    bodyFormData.append("tos_check_box", 1);
  } else {
    bodyFormData.append("gift_card_option_id", gift_card_option_id);
    bodyFormData.append("tos_check_box", 1);
  }
  bodyFormData.append("email", email);
  stripe_token_id
    ? bodyFormData.append("stripe_token_id", stripe_token_id)
    : bodyFormData.append("stripe_source_id", stripe_source_id);
  takeUTM(bodyFormData, utm);
  const url = !!ikPassSingle
    ? "inkind_cash/checkout_myself"
    : !ikPass
      ? "/checkout/myself"
      : !existingSubscription
        ? "/inkind_cash/subscriptions"
        : "/inkind_cash/subscriptions/update_subscription";

  return await axios.post(url, bodyFormData, axiosHeaders);
}

export async function sendGift(
  stripe_token_id,
  stripe_source_id,
  gift_card_option_id = null,
  gifter_first_name,
  gifter_last_name,
  gifter_email,
  custom_gifter_name,
  giftee_name,
  giftee_email,
  gift_note,
  userToken = null,
  notify_on,
  emailMeGift,
  bonusMeGift,
  utm,
  is_inkind_cash,
  inkind_cash_offer_id = null,
  ikPassSingle,
  header,
) {
  const auth = userToken ? "Bearer ".concat(userToken) : "";
  const axiosHeaders = {
    headers: {
      Authorization: auth,
      ...header,
    },
  };
  const bodyFormData = new FormData();

  stripe_token_id
    ? bodyFormData.append("stripe_token_id", stripe_token_id)
    : bodyFormData.append("stripe_source_id", stripe_source_id);
  if (!!ikPassSingle) {
    bodyFormData.append("gift_card_option_id", gift_card_option_id);
    bodyFormData.append("tos_check_box", 1);
  } else {
    bodyFormData.append(
      "gift_card_option_id",
      is_inkind_cash ? inkind_cash_offer_id : gift_card_option_id,
    );
  }
  bodyFormData.append("gifter_first_name", gifter_first_name);
  bodyFormData.append("custom_gifter_name", custom_gifter_name);
  bodyFormData.append("gifter_last_name", gifter_last_name);
  bodyFormData.append("gifter_email", gifter_email);
  bodyFormData.append("email", gifter_email);
  bodyFormData.append("giftee_name", giftee_name);
  bodyFormData.append("giftee_email", giftee_email);
  bodyFormData.append("tos_check_box", 1);
  bodyFormData.append("keep_gift_bonus", bonusMeGift);
  takeUTM(bodyFormData, utm);

  bodyFormData.append("gift_note", gift_note || "");

  if (!emailMeGift) {
    bodyFormData.append("giftee_email", giftee_email);
    bodyFormData.append("notify_on", notify_on);
  } else {
    bodyFormData.append("delivery_method", "print");
  }

  const url = !!ikPassSingle
    ? "inkind_cash/send_gift"
    : is_inkind_cash
      ? "/inkind_cash/gifts"
      : "/checkout/gift";
  return await axios.post(url, bodyFormData, axiosHeaders);
}

export async function expressSelf(
  stripe_token_id,
  email,
  gift_card_option_id,
  phone_number,
  first_name,
  last_name,
  utm,
  userToken,
  ikPass,
  ikPassSingle,
  existingSubscription,
  country,
  isAgreeAllChecked,
  headers,
) {
  const auth = userToken ? "Bearer ".concat(userToken) : "";
  const axiosHeaders = {
    headers: {
      Authorization: auth,
      ...headers,
    },
  };

  const bodyFormData = new FormData();
  if (!!ikPass) {
    bodyFormData.append(
      "inkind_cash_subscription_tier_id",
      gift_card_option_id,
    );
    bodyFormData.append("nation_id", country);
  } else if (!!ikPassSingle) {
    bodyFormData.append("gift_card_option_id", gift_card_option_id);
    bodyFormData.append("tos_check_box", 1);
  } else {
    bodyFormData.append("gift_card_option_id", gift_card_option_id);
    bodyFormData.append("tos_check_box", 1);
  }

  bodyFormData.append("stripe_token_id", stripe_token_id);
  bodyFormData.append("first_name", first_name);
  bodyFormData.append("last_name", last_name);
  bodyFormData.append("phone_number", phone_number);
  bodyFormData.append("email", email);
  if (isAgreeAllChecked) {
    bodyFormData.append("has_opted_out_email", "false");
    bodyFormData.append("has_opted_out_sms", "false");
  }

  takeUTM(bodyFormData, utm);
  const url = !!ikPassSingle
    ? "inkind_cash/checkout_myself"
    : !ikPass
      ? "/checkout/myself"
      : "/inkind_cash/express_subscriptions";

  return await axios.post(url, bodyFormData, axiosHeaders);
}

export async function expressGift(
  stripe_token_id,
  gift_card_option_id,
  phone_number,
  gifter_first_name,
  gifter_last_name,
  gifter_email,
  custom_gifter_name,
  giftee_name,
  giftee_email,
  gift_note,
  notify_on,
  emailMeGift,
  bonusMeGift,
  utm,
  is_inkind_cash,
  inkind_cash_offer_id = null,
  userToken,
  ikPassSingle,
  isAgreeAllChecked,
  header,
) {
  const auth = userToken ? "Bearer ".concat(userToken) : "";
  const axiosHeaders = {
    headers: {
      Authorization: auth,
      ...header,
    },
  };
  const bodyFormData = new FormData();
  bodyFormData.append("stripe_token_id", stripe_token_id);
  if (!!ikPassSingle) {
    bodyFormData.append("gift_card_option_id", gift_card_option_id);
  } else {
    bodyFormData.append("gift_card_option_id", gift_card_option_id);
  }
  bodyFormData.append("first_name", gifter_first_name);
  bodyFormData.append("last_name", gifter_last_name);
  bodyFormData.append("email", gifter_email);
  bodyFormData.append("custom_gifter_name", custom_gifter_name);
  bodyFormData.append("giftee_name", giftee_name);
  bodyFormData.append("giftee_email", giftee_email);
  bodyFormData.append("tos_check_box", 1);
  bodyFormData.append("phone_number", phone_number);
  bodyFormData.append("keep_gift_bonus", bonusMeGift);
  takeUTM(bodyFormData, utm);
  bodyFormData.append("gift_note", gift_note || "");

  if (!emailMeGift) {
    bodyFormData.append("giftee_email", giftee_email);
    bodyFormData.append("notify_on", notify_on);
  } else {
    bodyFormData.append("delivery_method", "print");
  }
  if (isAgreeAllChecked) {
    bodyFormData.append("has_opted_out_email", "false");
    bodyFormData.append("has_opted_out_sms", "false");
  }

  const url = !!ikPassSingle
    ? "inkind_cash/send_gift"
    : is_inkind_cash
      ? "/inkind_cash/express_gifts"
      : "/express_checkout/gift";

  return await axios.post(url, bodyFormData, axiosHeaders);
}
